import React from 'react';
import styled from 'styled-components';
import ribbon from '../../styles/images/bg-section.png';

const StyledWrap = styled.div`
  width: 100%;
  left: 0;
  margin-top: 60px;
`;

export default function () {
  return (
    <StyledWrap>
      <img width="100%" src={ribbon} alt="bg" />
    </StyledWrap>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/Ribbon.js